import { Injectable } from '@angular/core';
import { ProductModel } from '../models/product.model';
import { HttpClient } from '@angular/common/http';
//import{ GlobalConstants } from '../../common/global-constants';
import { UserService } from './user.service';
import { FormGroup } from '@angular/forms';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  //readonly BaseURI = GlobalConstants.apiURL;
  BaseURI : string;
  readonly apiController = "/Products";
  form : FormGroup = ProductModel.getFormGroup();
  constructor(private http : HttpClient, private userservice : UserService) {
    this.BaseURI = window.location.origin + "/api";

  }

  populateForm (data){
    //ProductModel.populateForm(this.form, data);
    console.log("populateForm");
    this.form.setValue(data);
  }
  initializeFormGroup()
  {
    ProductModel.initializeFormGroup(this.form);
  }
 // postCustomerDetail(form : Customer)
  insertData(item : ProductModel)
  {
     item.createBy = this.userservice.getUserID();
     return this.http.post(this.BaseURI + this.apiController, _.omit(item, ["productId", "createTime"]));
  }

  updateData(item : ProductModel)
  {
     return this.http.put(this.BaseURI + this.apiController + "/" + item.productId, item);
  }

  getList()
  {
    return this.http.get(this.BaseURI + this.apiController);
  }

  deleteData(id)
  {
    return this.http.delete(this.BaseURI + this.apiController + "/" + id);

  }

}
